// extracted by mini-css-extract-plugin
export var quillEditor = "_j1-1";
export var variable = "_j1-0";